'use client';
import React, { useState } from 'react';
import { User, Bell, Calendar, Plug, Users } from 'lucide-react';
import ProfileSettings from './ProfileSettings';
import NotificationSettings from './NotificationSettings';
import ReportScheduleSettings from './ReportScheduleSettings';
import IntegrationSettings from './IntegrationSettings';
import TeamAccessSettings from './TeamAccessSettings';
import Icon from '@/components/ui/AppIcon';


const categories = [
  { id: 'profile', label: 'Profile', icon: User },
  { id: 'notifications', label: 'Notifications', icon: Bell },
  { id: 'reports', label: 'Report Schedules', icon: Calendar },
  { id: 'integrations', label: 'Integrations', icon: Plug },
  { id: 'team', label: 'Team Access', icon: Users },
];

export default function SettingsContent() {
  const [activeCategory, setActiveCategory] = useState('profile');

  return (
    <div className="fade-in">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">Settings</h1>
        <p className="text-sm text-muted-foreground mt-0.5">Manage your account, notifications, and team preferences</p>
      </div>
      <div className="flex gap-6 flex-col lg:flex-row">
        {/* Left nav */}
        <div className="lg:w-56 xl:w-64 flex-shrink-0">
          <nav className="card-surface p-2 space-y-0.5">
            {categories?.map((cat) => {
              const Icon = cat?.icon;
              const isActive = activeCategory === cat?.id;
              return (
                <button
                  key={`settings-nav-${cat?.id}`}
                  onClick={() => setActiveCategory(cat?.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 btn-press ${
                    isActive
                      ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                >
                  <Icon size={16} />
                  {cat?.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Right content */}
        <div className="flex-1 min-w-0">
          {activeCategory === 'profile' && <ProfileSettings />}
          {activeCategory === 'notifications' && <NotificationSettings />}
          {activeCategory === 'reports' && <ReportScheduleSettings />}
          {activeCategory === 'integrations' && <IntegrationSettings />}
          {activeCategory === 'team' && <TeamAccessSettings />}
        </div>
      </div>
    </div>
  );
}